import sample from './sample.js';

// Shuffle a collection.
export default function shuffle(obj) {
  return sample(obj, Infinity);
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/shuffle.js
// module id = 969
// module chunks = 0